import de from "./de";
import en from "./en";
import es from "./es";
import fr from "./fr";
import it from "./it";
import pl from "./pl";

// The widget's own static chrome, one module per locale. Italian is the language
// the copy is authored in; the rest are hand-translated here rather than fetched,
// because these strings ship with the bundle and never vary per hotel. The
// hotel-configurable copy (welcome message, shortcut buttons, teaser pills) is a
// separate thing entirely and arrives from the backend per locale.
//
// Every locale must carry the identical key set: several call sites index this
// object dynamically (localization.get(lang)[cta.key]), so a missing key renders
// as `undefined` rather than falling back. localization.test.ts enforces that.
const LOCALES: Record<string, any> = { it, en, de, es, fr, pl };

const localization: any = {
  ...LOCALES,

  get: function (language: string) {
    // Unknown locales get English, matching the backend's
    // requested -> en -> it fallback for the configurable copy.
    return LOCALES[language] ?? LOCALES.en;
  },
};

export const SUPPORTED_LANGUAGES = Object.keys(LOCALES);

export default localization;
